import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { theme } from 'antd'
import { RxDragHandleDots2 } from 'react-icons/rx'

import type { ReactNode } from 'react'

interface SortableItemProps {
    id: string
    children: ReactNode
}

/**
 * Рядок сортованого списку налаштувань з drag-handle (@dnd-kit).
 * Візуал: ручка перетягування + довільний вміст рядка.
 */
export const SortableItem = ({ id, children }: SortableItemProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })
    const { token } = theme.useToken()

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 4px',
        background: token.colorBgContainer,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        opacity: isDragging ? 0.6 : 1,
    }

    return (
        <div ref={setNodeRef} style={style}>
            <span
                {...attributes}
                {...listeners}
                style={{ cursor: 'grab', display: 'flex', color: token.colorTextTertiary, touchAction: 'none' }}
            >
                <RxDragHandleDots2 style={{ fontSize: 18 }} />
            </span>
            {children}
        </div>
    )
}
